const UploadInput = ({ title, value, onValueChange, setPreview }) => {
    function getImgData(e) {
        onValueChange(e.target.files[0].name.substring(0, 15))
        const files = e.target.files[0];
        console.log(files)
        if (files) {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(files);
            fileReader.addEventListener("load", function () {
                setPreview(fileReader.result)
            });
        }
    }
    return (
        <div className='w-full md:w-auto'>
            <div className='flex gap-3 items-center '>
                <p className='font-bold text-base'>{title}</p>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                </svg>
            </div>
            <div className='mt-2 relative w-full md:w-[180px] lg:w-[170px] h-40'>
                <input type="file" accept="image/*" className="bg-red-500 w-full h-full relative z-20 opacity-0 rounded-md" onChange={getImgData} />
                <div className={`bg-fileUpload flex flex-col justify-center items-center border border-dotted border-darkGrey w-full h-full rounded-md absolute top-0 z-10`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-cloud-arrow-up-fill text-label" viewBox="0 0 16 16">
                        <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 5.146a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2z" />
                    </svg>
                    <p className='text-label font-normal'>{value ? value : 'Add files here'}</p>
                </div>
            </div>
        </div>
    )
}

export default UploadInput
